import { map } from "rxjs/operators";
export function mapButtonActiveUndeterminateProgress() {
    return (source) => source.pipe(map(([indeterminateLoading, progress, indeterminedLoadingTime, indeterminateDurationMs]) => {
        if (!indeterminedLoadingTime) {
            return false;
        }
        if (progress !== 100 &&
            progress !== 0 &&
            indeterminateDurationMs !== null) {
            return false;
        }
        return (indeterminedLoadingTime < Number(indeterminateDurationMs) ||
            indeterminateLoading);
    }));
}
